console.log('✅ catalog-blog-categories-sidebar.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { loadTextTranslations } from '../../js/translator.js';
import {
  initLinksTranslator,
  getLinksTranslationByKeyFromCurrentLanguageProxy,
} from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import { fetchAllBlogCategories } from '../../services/data-services/blog-data-service.js';

let _tempTextTranslator = null;

export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

const lang = appState.SiteLanguageCookie;

export async function buildComponentCatalogBlogCategoriesForMainSidebar() {
  console.log(
    `🔄 Building Component: buildComponentCatalogBlogCategoriesForMainSidebar - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    let htmlToRender = '';

    if (isNodeEnvironment()) {
      htmlToRender = await buildActualContent();
    } else {
      htmlToRender = await buildPageSkeleton();
    }

    const html = `
      
    ${htmlToRender}
          
        `;

    console.log('✅ BlogCategoriesSidebar built successfully.');
    // 4️⃣ Defer event wiring until after insertion
    registerEventListenerToAttach(async () => initbuildComponentCatalogBlogCategoriesForMainSidebar());

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentCatalogBlogCategoriesForMainSidebar:', err);
    return '<div>Error loading buildComponentCatalogBlogCategoriesForMainSidebar </div>';
  }
}

export async function buildPageSkeleton() {
  //  // Top two “featured” cards
  //  const topCardsSkeletonHtml = `
  //    <br />
  //  <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //`;

  //  const topCardsSkeletonHtml2 = `
  //  <div class="grid-blog-category-home-featured-top-card my-fake-image-height-400">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //  `;

  //  let middleCardsSkeleton = '';
  //  for (let i = 0; i < 4; i++) {
  //      middleCardsSkeleton += `
  //    <div class="grid-blog-home-featured-middle-section-card my-fake-image-height-400">
  //                                  <div class="my-site-lazy-loading-card">
  //                                      <div class="my-site-lazy-loading-card-movement"></div>
  //                                  </div>
  //                              </div>

  //  `;
  //  }

  //  // Sidebar section: repeat 5 times
  //  let sideBarCardsSkeleton = '  <br>  <br>';
  //  for (let i = 0; i < 5; i++) {
  //      sideBarCardsSkeleton += `
  //              <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
  //                          <div class="my-site-lazy-loading-card">
  //                              <div class="my-site-lazy-loading-card-movement"></div>
  //                          </div>
  //                      </div>

  //                      <br />

  //  `;
  //  }

  //  // Middle section: repeat 6 times
  //  let bottomCardsSkeleton = '';
  //  for (let i = 0; i < 6; i++) {
  //      bottomCardsSkeleton += `
  //   <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
  //                      <div class="my-site-lazy-loading-card">
  //                      <div class="my-site-lazy-loading-card-movement"></div>
  //                  </div>
  //              </div>
  //  `;
  //  }

  const html = `
    <div id="placeholder-buildComponentCatalogBlogCategoriesForMainSidebar">
  
   

         </div>
    
   
  `;

  return html;
}

export async function buildActualContent() {
  console.log(`🔄 Building Component: BlogCategoriesSidebar - lang: ${lang}`);
  try {
    // 1️⃣ Load translations
    await initTempTextTranslator(lang);
    await initTempLinksTranslator(lang);

    const {
      keyArticlesAndBlog: lblArticlesAndBlog,
      keyBlogHome: lblBlogHome,
    } = _tempTextTranslator;

    const { keyBlog: linkBlog } = _tempLinksTranslator;

    const blogCategories = await fetchAllBlogCategories(); // aka blog categories

    const blogCatLinksHtmlRows = blogCategories
      // only the ones marked for the home‐page sidebar
      .filter(b => b.isOnHomePageSideNav === true)
      // then map to your <a> tags
      .map(b => {
        const link = `${linkBlog}/${b.articleCategoryID}/${b.seoPageName}`;
        return `
                    <a href="${link}"         data-close-on-click>     ${b.name}       </a>`;
      })
      .join('');

    const html = ` <div id="btnSideBarNavDropdown-btn-blog" class="SideBarNavDropdown-btn-blog" data-dropdown-id="blogSidebarDropdown">
        ${lblArticlesAndBlog}
      
      <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="NewNavSidePanelDropdownFa-caret-down">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    </svg>
      </div>


      <div class="NewNavSidePanelDropdown-container" style="display:none;">

        <a href="${linkBlog}"   data-close-on-click>    ${lblBlogHome}       </a>
        
      ${blogCatLinksHtmlRows}

      </div>

      `;

    return html;
  } catch (err) {
    console.error('❌ Error building BlogCategoriesSidebar:', err);
    return `<div class="error">Error loading BlogCategoriesSidebar</div>`;
  }
}


export async function initbuildComponentCatalogBlogCategoriesForMainSidebar() {
  try {
    let htmlToRender = await buildActualContent();

    const currentPlacholder = document.querySelector(
      '#placeholder-buildComponentCatalogBlogCategoriesForMainSidebar'
    );
    if (currentPlacholder) {
      currentPlacholder.innerHTML = htmlToRender;
    }

    await setupGeneralListeners();

    console.log('✅ BlogCategoriesSidebar listeners attached.');
  } catch (err) {
    console.error('❌ Error attaching BlogCategoriesSidebar listeners:', err);
  }
}

export async function setupGeneralListeners() {
  let isDropdownOpen = false;

  const button = document.getElementById('btnSideBarNavDropdown-btn-blog');
  if (!button) return;

  // Named handler scoped to button and isDropdownOpen state
  const onBlogNavToggleClick = async function() {
    button.classList.toggle('NewNavSidePanelDropdownActive');
    const dropdownContent = button.nextElementSibling;

    isDropdownOpen = !isDropdownOpen;
    dropdownContent.style.display = isDropdownOpen ? 'block' : 'none';

    if (isDropdownOpen) {
      console.log('🌐 Populating blog categories on dropdown open');
      // await populateBlogCategoriesDropdown();
    }
  };

  // Remove any previously attached instance of this handler
  button.removeEventListener('click', onBlogNavToggleClick);

  // Attach fresh instance
  button.addEventListener('click', onBlogNavToggleClick);
}
